/* RESPONSIBLE TEAM: team-workflows */
import {
  PHONE_REUSABLE_TARGET,
  TRIGGERABLE_BOT_TYPE,
  FROM_ANOTHER_WORKFLOW,
  PHONE_REUSABLE_TRIGGER,
  WORKFLOWS_SETUP_TRIGGER_DURING_CONVERSATION,
  WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION,
  WORKFLOWS_SETUP_TRIGGER_INTERNAL_PROCESS,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import NewPhoneCallTargetEditorConfig from 'embercom/objects/visual-builder/configuration/editor/new-phone-call-target';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
// eslint-disable-next-line no-restricted-imports
import { getApp } from 'embercom/lib/container-lookup';
import CustomBotConfig, { type ColumnConfigs } from '../custom-bot';
import type { BotConfigTarget } from '../configuration';

export default class PhoneReusableCustomBotConfig extends CustomBotConfig {
  get target(): BotConfigTarget {
    return PHONE_REUSABLE_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return PHONE_REUSABLE_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.phone-reusable.title';
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.phone-reusable.description';
  }

  get icon(): InterfaceIconName {
    return 'phone';
  }

  get columnKeys() {
    let columnKeys: (keyof ColumnConfigs)[] = [
      'title',
      'state',
      'updatedAt',
      'lastUpdatedBy',
      'sentCount',
      'engagedPercent',
      'completedPercent',
      'createdAt',
      'firstWentLiveAt',
    ];

    if (getApp().canUseFeature('rd-services-view-fin-involvement-stat')) {
      columnKeys.splice(columnKeys.length - 2, 0, 'finStepReached');
    }

    return columnKeys;
  }

  get editorConfig() {
    return new this.EditorConfigClass({
      targetChannels: this.customBot?.targetChannels,
      areStepPaywallsActive: this.areStepPaywallsActive,
      workflow: this.workflow,
    });
  }

  get EditorConfigClass() {
    return NewPhoneCallTargetEditorConfig;
  }

  get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  get triggerContextType() {
    return FROM_ANOTHER_WORKFLOW;
  }

  visibleToApp(app: any) {
    return app.canUsePhoneWorkflowTrigger as boolean;
  }

  get workflowsSetupTriggerType(): string[] {
    return [
      WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION,
      WORKFLOWS_SETUP_TRIGGER_DURING_CONVERSATION,
      WORKFLOWS_SETUP_TRIGGER_INTERNAL_PROCESS,
    ];
  }
}
